<template>
  <div>
    <program-division-index
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :title="$t('menu.program_division_list')"
      :serviceName="serviceName"
    />
  </div>
</template>

<script>
import ProgramDivisionIndex from "./ProgramDivisionIndex";
export default {
  name: "Index",
  data() {
    return {
      serviceName: "program-divisions",
      formSearch: [
        {
          label: this.$t("program_division.name"),
          name: "name__~",
          value: "",
          type: "input"
        }
      ],
      columns: {
        id: this.$t("program_division.id"),
        name: this.$t("program_division.name"),
        description: this.$t("program_division.description"),
        created_at: this.$t("program_division.created_at"),
        updated_at: this.$t("program_division.updated_at")
      }
    };
  },
  components: { ProgramDivisionIndex },
  methods: {},
  mounted() {}
};
</script>
